<ngx-premium-trial-reminder></ngx-premium-trial-reminder>
<div class="d-flex align-items-center justify-content-center">
<!-- <div class="custom-app-band">
  <span><b>[New!]</b> Get your custom-branded app with your logo on the app store. (<a href="https://go.trainerfriend.com/customapp" target="_blank">Learn more...</a>)</span>
</div> -->
</div>
<!--<nb-card   *ngIf="!(user?.selectedPlan == 'propromo' && user?.planCode == 'free') && shouldManageSubscription && user?.isAmbasador == false && user?.selectedPlan != user?.planCode">
  <nb-card-header>
    <div i18n="@@Notifications" class="title">Notifications</div>
  </nb-card-header>

  <nb-card-body>
    <nb-alert outline="success" role="warning"

      (close)="onClosePaymentWarning()">
      <div i18n="@@InvalidSubscription">
        You are currently on
        <span class="text-uppercase">{{user?.planCode}}</span> plan, but have selected the
        <span class="text-uppercase">{{user?.selectedPlan}}</span> plan.
      </div>
      <button i18n="@@ManageSubscription" nbButton  class="mt-3 mr-3" (click)="onManageSubscription()"
        routerLink="pages/CalorieFriend/manage-subscription">
        Manage subscription
      </button>
    </nb-alert>
  </nb-card-body>
</nb-card>-->


<div style="display: flex;" class="justify-content-end">
<div [class.padding-in-tutorial]="joyrideService.isTourInProgress()" [class.in-tutorial]="isAddNewTutorial"
title="Adding new Clients" [joyrideStep]="TutorialIDs.AddNewPatient" stepPosition="left"
[stepContent]="customAddNewTutorialContent">

<button i18n="@@AddNew" nbButton type="submit"  (click)="onAddPatient()"
class="btn-circle btn-xl btn-main btn-circle btn-xl">

<nb-icon icon="plus"></nb-icon> <span>Add New Client</span>


</button>
</div>

</div>

<div style="height: 10px;"></div>
<nb-card>
  <nb-card-header>
    <div class="title"><span i18n="@@PatientsList">Clients</span> {{patientsCountInfo}}</div>
    <div class="actions">
      <!-- Search -->
      <nb-form-field class="search-field">
        <input nbInput #search shape="semi-round" fieldSize="small" class="search" i18n-placeholder="@@SearchThreeDots"
          style="width: 125px;">
        <nb-icon nbSuffix icon="search-outline" pack="eva"></nb-icon>
      </nb-form-field>
      <!-- Add -->
    </div>
  </nb-card-header>

  <nb-card-body>


    <ngx-skeleton-user-list *ngIf="!contentLoaded"></ngx-skeleton-user-list>



    <mat-table [class.hidden]="!contentLoaded" [dataSource]="dataList" matSort [matSortDisableClear]="true" (matSortChange)="onSortChanged($event)">7

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
        <mat-cell *matCellDef="let row" data-label="">
          <app-custom-patient-name [rowData]="row"></app-custom-patient-name>
          <div class="compliance-score">
            <app-compliance-gauge [value]="row.workoutCompliance7"  icon="dumbbell"  size="48"></app-compliance-gauge>
            <app-compliance-gauge [value]="row.diaryCompliance7" icon="utensils"  size="48"></app-compliance-gauge>
          </div>
        </mat-cell>
      </ng-container>

      <!-- Plans Column -->
      <ng-container matColumnDef="plansCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Plans </mat-header-cell>
        <mat-cell *matCellDef="let row" data-label="Plans">{{row.plansCount}} {{row.plansCount > 1 ? 'Plans' : 'Plan' }}, {{row.goalsCount}} {{row.goalsCount > 1 ? 'Goals' : 'Goal' }}</mat-cell>
      </ng-container>

      <!-- Compliance Column -->
      <ng-container matColumnDef="compliance">
        <mat-header-cell *matHeaderCellDef mat-sort-header> 7-Day Compliance </mat-header-cell>
        <mat-cell *matCellDef="let row" data-label="Compliance">
          <div class="d-flex py-1">
            <app-compliance-gauge [value]="row.workoutCompliance7"  icon="dumbbell"  size="64"></app-compliance-gauge>
            <app-compliance-gauge [value]="row.diaryCompliance7" icon="utensils"  size="64"></app-compliance-gauge>
          </div>
        </mat-cell>
      </ng-container>

      <!-- Created Date Column -->
      <ng-container matColumnDef="createdDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 100px;"> Created </mat-header-cell>
        <mat-cell *matCellDef="let row" data-label="Created">   <span style="float: right; color:gray; font-weight: 500;">{{row.createdDate | date:'mediumDate'}}</span> </mat-cell>
      </ng-container>

      <!-- edit button column -->
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef style="width: 25px;"></mat-header-cell>
        <mat-cell *matCellDef="let row" data-label="Actions">
          <div style="display:inline;" >
            <span class="position-relative">
            <a href='javascript:void(0)' (click)="openChatWindow(row.id)">
              <i class="far fa-comments action-icon mx-2"></i>
              <div class="chat-notification-badge" *ngIf="row.chatThread?.unSeenCount" >{{row.chatThread?.unSeenCount}}</div>
              <!-- <img src="assets/icons/trash-2-outline.svg" title="Delete" class="img-archive" width="24" height="24"> -->
            </a>
            </span>
            <a href='javascript:void(0)' (click)="onArchive(row.id)" *ngIf="!row.isArchived">
              <i class="far fa-trash-alt action-icon mx-2"></i>
              <!-- <img src="assets/icons/trash-2-outline.svg" title="Delete" class="img-archive" width="24" height="24"> -->
            </a>

            <a href='javascript:void(0)' (click)="onUnarchive(row.id)" *ngIf="row.isArchived">
              <i class="fas fa-trash-restore action-icon mx-2"></i>
              <!-- <img style="width: 20px; margin-left: 3px;" src="assets/icons/restore-outline.svg" title="Restore"
                class="img-archive" width="24" height="24"> -->
            </a>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <mat-paginator #paginator [length]="totalCount" [pageSize]="10" [pageSizeOptions]="[10, 25, 50]"
      (page)="loadDataList(true)" [class.hidden]="totalCount === 0"></mat-paginator>


  </nb-card-body>

  <ng-template #customAddNewTutorialContent>
    Adding new clients is simple, tap the “Add New” client and we will show you how it works!
  </ng-template>

  <nb-card-footer>
    <div class="float-right d-flex align-items-center">
      <nb-checkbox i18n="@@ShowArchived" status="info" class="archived mr-3" (checkedChange)="onArchivedChange($event)">
        Show Deleted</nb-checkbox>

        <button i18n="@@AddNew" nbButton type="submit"  (click)="onAddPatient()"
          class="btn-circle btn-xl btn-main btn-circle btn-xl">Add New Client</button>
    </div>
  </nb-card-footer>
</nb-card>


<ng-template #complianceGauge let-value>
  <div class="position-relative gauge-container">
    <i class="fas fa-dumbbell"></i>
    <mwl-gauge
      [max]="100"
      [dialStartAngle]="-90"
      [dialEndAngle]="-90.001"
      [value]="value * 100"
      [animated]="true"
      [animationDuration]="1"
      [label]="gaugeLabel"
    ></mwl-gauge>
  </div>
</ng-template>
